<template>
    <tr>
        <th>{{ label }}</th>
        <td :colspan="colspan">
            {{ content }}
            <slot />
        </td>
    </tr>
    <!-- <v-row class="counsel-report-row">
        <v-col :cols="labelCols" class="counsel-report-label">{{ label }}</v-col>
        <v-col :cols="contentCols" class="counsel-report-content">
            {{ content }}
            <slot />
        </v-col>
    </v-row> -->
</template>

<script>
export default {
    props: {
        label: String,
        content: String,
        colspan: String,
        isInner: { type: Boolean, default: false },
    },
    computed: {
        labelCols() {
            return this.isInner ? 4 : 2;
        },
        contentCols() {
            return 12 - this.labelCols;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.table--primary{
    width:100%;
    letter-spacing: -.04em;
    border-spacing: 0;
    border-top:1px solid $color-primary;
    th, td{
        font-size: 16px;
        border-bottom:1px solid #e6e6e6;
        padding: 15px 20px;
    }
    th{
        font-weight:500;
        color:#222;
        background-color: #f7fcfe;
    }
    td{
        color: #7e7e7e;
    }
}
@media (max-width:768px){
    .table--primary{
        tr{
            th, td{
                font-size: 14px;
                padding:10px 15px;
            }
        }
    }
    .table--primary, .table--primary tr, .table--primary th, .table--primary td{
        display: block;
    }
}
</style>